var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinearrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 201,
    height: 166,
    viewBox: "0 0 201 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.445 157.903C80.9868 109.794 117.537 48.5584 48.9288 8.49561",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1252 10.1249C44.4459 9.68579 43.4441 7.95517 43.8875 6.25946C44.331 4.56374 46.0517 3.54507 47.7309 3.9842C49.4102 4.42332 50.412 6.15394 49.9686 7.84965C49.5252 9.54536 47.8044 10.564 46.1252 10.1249Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M151.811 161.019C150.132 160.58 149.13 158.85 149.574 157.154C150.017 155.458 151.738 154.44 153.417 154.879C155.096 155.318 156.098 157.048 155.655 158.744C155.211 160.44 153.49 161.459 151.811 161.019Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinearrow);
export default __webpack_public_path__ + "static/media/linearrow.d0b936e8e92103b841d6e5de01625aed.svg";
export { ForwardRef as ReactComponent };